
import Link from 'next/link';
import {usePathname, useRouter} from 'next/navigation';
import {headerNavData} from 'data/navigation';
import Dropdown from '../Dropdown/Dropdown';

import * as platform from 'data/platform_dropdown';
import * as company from 'data/company_dropdown';
import * as cylerian from 'data/cylerian_dropdown';
import * as partners from 'data/partners_dropdown';
import * as services from 'data/services_dropdown';

const dropdowns = {
  platform,
  company,
  cylerian,
  partners,
  services
};

const Navigation = ({closeMenu}) => {
  const pathname = usePathname();
  const navLinks = (headerNavData).map((item, key) => {
    const {dropdown, title, path} = item;
    if (dropdown) {
      return <Dropdown key={key} {...dropdowns[dropdown]} closeMenu={closeMenu}/>;
    }
    return <li className='navItem' key={key}>
      <Link href={path} className={`nav-link ${path === '/' ? pathname === '/' && 'active' : pathname.startsWith(path) && 'active'}`} onClick={closeMenu}>
        {title}
      </Link>
    </li>;
  });

  return (
    <nav className='nav'>
      <ul className='nav-list'>
        {navLinks}
        <div className='center-btn'>
          <Link href='/contact' className='btn book-btn' onClick={closeMenu} scroll={false}>
            Book a demo
            <span className='arrow-wrapper'>
              <span className='arrow'></span>
            </span>
          </Link>
        </div>
      </ul>
    </nav>
  );
};

export default Navigation;

